module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David L. Golemon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("David Lynn Golemon was raised in Chino, California. He has raised three great children and now makes his home in New York, where he is currently working on the next "), _c('I', [_vm._v("Event Group")]), _vm._v(" novel.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9GX9HV/tc-custom/9781429961639.jpg?1725275240837",
      "alt": "This image is the cover for the book Ancients, Event Group Thrillers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ancients, Event Group Thrillers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("America’s most secret government organization races to stop descendants of an ancient civilization from destroying Earth in this thrilling adventure.")]), _c('br'), _c('br'), _vm._v("Eons before the birth of the Roman Empire, there was a civilization dedicated to the sciences of earth, sea, and sky. In the City of Light lived people who made dark plans to lay waste to their uncivilized neighbors using the very power of the planet itself. As the great science of their time was brought to bear on the invading hordes, hell was set loose on Earth. And the civilization of Atlantis disappeared in a suicidal storm of fire and water . . . "), _c('br'), _c('br'), _vm._v("Now history threatens to repeat itself. The great weapon of the Ancients has been discovered in the South Pacific, and it is being deciphered by men of hatred who want to unleash hell on Earth once again. This time, it’s up to the Major Jack Collins and the Event Group—comprised of the nation’s most brilliant minds in the fields of science, philosophy, and the military to find the truth behind the world’s greatest unsolved myths—to end the cycle of destruction. Meanwhile, the seas rise, the earth cracks, and entire cities crumble to dust as the evil plan mapped out thousands of years before begins to take shape . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0